import React, { useState } from 'react';

const UniverseSection = () => {
  const [selectedImage, setSelectedImage] = useState(null);

  const universeImages = [
    {
      url: 'https://customer-assets.emergentagent.com/job_portal-arcano-1/artifacts/c77q0jvo_Hailuo_Image_A%20lone%20man%20with%20long%20black%20hai_409703367398391819%20%281%29.png',
      title: 'El Redentor',
      description: 'Un salvador renacido en un mundo que sepultó su fe.',
      imagePosition: '50% 12%',
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_portal-arcano-1/artifacts/grx7qyt9_394280682662809611.png',
      title: 'El Portal',
      description: 'Caelus tuvo que atravesar el portal para llegar a nuestro mundo.',
      imagePosition: '50% 50%',
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_portal-arcano-1/artifacts/6wi90o4v_392070729599819780.png',
      title: 'El Abismo',
      description: 'El Infierno no se detendrá ante nada.',
      imagePosition: '50% 22%',
    },
  ];

  return (
    <section id="universo" className="reveal relative py-24 px-6 bg-gradient-to-b from-black via-red-950/10 to-black">
      <div className="max-w-7xl mx-auto">
        <div className="section-divider mb-12"></div>

        <div className="text-center mb-16 reveal">
          <h2 className="section-title text-4xl md:text-6xl font-bold mb-6 glow-red">
            El Universo Extendido
          </h2>
          <p className="text-xl text-gray-400 max-w-3xl mx-auto leading-relaxed">
            Cada imagen cuenta una historia. Cada historia es parte de una guerra. Pero el conflicto también es interior.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 mb-16">
          {universeImages.map((item, index) => (
            <div
              key={index}
              className="card-inferno reveal cursor-pointer overflow-hidden group"
              style={{ transitionDelay: `${index * 90}ms` }}
              onClick={() => setSelectedImage(item)}
            >
              <div className="relative overflow-hidden">
                <img
                  src={item.url}
                  alt={item.title}
                  className="w-full h-80 object-cover transition-transform duration-500 group-hover:scale-110"
                  style={{ objectPosition: item.imagePosition }}
                />
                <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-transparent to-transparent"></div>
                <div className="absolute inset-0 bg-gradient-to-t from-black via-black/50 to-transparent opacity-70 group-hover:opacity-85 transition-opacity duration-300"></div>
              </div>
              <div className="p-6">
                <h3 className="text-2xl font-bold mb-2 text-orange-500 group-hover:glow-orange transition-all duration-300">
                  {item.title}
                </h3>
                <p className="text-gray-400">
                  {item.description}
                </p>
              </div>
            </div>
          ))}
        </div>

        <div className="max-w-4xl mx-auto text-center mb-16 reveal">
          <div className="inferno-panel border border-red-900/30 p-8 md:p-12">
            <p className="text-lg md:text-xl text-gray-300 leading-relaxed mb-6">
              <span className="text-orange-500 font-bold">Las Siete Potestades del Infierno</span> han comenzado a despertar.
              <br />
              El ritual se acerca.
              <br />
              Solo un redentor puede detenerlo…
              <br />
              pero el precio de la salvación podría ser más alto que el propio infierno.
            </p>
            <p className="text-base text-gray-400 leading-relaxed italic">
              "Cuando el fin llegue… el fuego que una vez quebró al cielo,
              <br className="hidden md:block" />
              consumirá también la Tierra."
            </p>
          </div>
        </div>

        <div className="max-w-4xl mx-auto text-center reveal">
          <div className="inferno-panel border border-orange-900/30 p-8 md:p-12">
            <h3 className="section-subtitle text-3xl md:text-4xl text-orange-500 mb-6">
              La Profecía
            </h3>
            <p className="text-lg md:text-xl text-gray-300 italic leading-relaxed">
              "El Último Redentor caminará entre los hombres,
              <br className="hidden md:block" />
              para contener el infierno con sus propias cicatrices."
            </p>
          </div>
        </div>
      </div>

      {selectedImage && (
        <div
          className="fixed inset-0 z-50 bg-black/95 flex items-center justify-center p-6"
          onClick={() => setSelectedImage(null)}
        >
          <div className="max-w-5xl w-full" onClick={(e) => e.stopPropagation()}>
            <img
              src={selectedImage.url}
              alt={selectedImage.title}
              className="w-full h-auto max-h-[80vh] object-contain mb-6"
            />
            <div className="text-center">
              <h3 className="text-3xl font-bold mb-3 text-orange-500">
                {selectedImage.title}
              </h3>
              <p className="text-xl text-gray-300">
                {selectedImage.description}
              </p>
            </div>
          </div>
          <button
            onClick={() => setSelectedImage(null)}
            className="absolute top-6 right-6 text-white text-4xl hover:text-orange-500 transition-colors"
          >
            ×
          </button>
        </div>
      )}
    </section>
  );
};

export default UniverseSection;
